import { ReallocationSource, ReallocationTarget } from '../../../types/reallocation/Reallocation'

const reallocationEndpoints = {
  list: (companyId: string) => `/companies/${companyId}/accounting/reallocations` as const,
  detail: (companyId: string, id: ReallocationSource['id']) =>
    `/companies/${companyId}/accounting/reallocations/${id}` as const,
  targets: (companyId: string, sourceId: ReallocationSource['id']) =>
    `/companies/${companyId}/accounting/reallocations/${sourceId}/targets` as const,
  target: (companyId: string, sourceId: ReallocationSource['id'], targetId: ReallocationTarget['id']) =>
    `/companies/${companyId}/accounting/reallocations/${sourceId}/targets/${targetId}` as const
}

export default reallocationEndpoints
